import * as React from "react"

export type ModalFooterProps = {
    renderButtons: () => React.ReactNode
}

export const ModalFooter = (props: ModalFooterProps) => {
    return (
        <div className={classes.wrap}>
            <div className={classes.separator} />
            <div className={classes.buttonsWrap}>{props.renderButtons()}</div>
        </div>
    )
}

const classes = {
    wrap: "",
    separator: "border-b border-solid border-gray-200",
    buttonsWrap: "py-4 px-6 md:px-10",
}
